import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import "core-js/modules/es.error.cause.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6bede237"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  style: {
    "margin-bottom": "20px",
    "height": "600px"
  }
};
const _hoisted_3 = {
  style: {
    "text-align": "right"
  }
};
import { ref } from 'vue';
// import { useVModel } from '@vueuse/core'
import { ElMessage } from 'element-plus';
import { Plus, Delete } from '@element-plus/icons-vue';
import 'vue-cropper/dist/index.css';
import { VueCropper } from 'vue-cropper';
import Compressor from 'compressorjs';

// import { uploadTenantImage } from '@/api/tenant'
import { getOSSClient } from '@/utils/sts';
export default {
  __name: 'index',
  props: {
    modelValue: {
      type: [String, null],
      required: true
    },
    width: {
      type: Number,
      default: 250
    },
    height: {
      type: Number,
      default: 250
    },
    id: {
      type: [String, Number],
      default: 0
    },
    path: {
      type: String,
      default: 'images'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;

    // const file = useVModel(props, 'modelValue', emits)

    const option = ref({
      img: '',
      size: 1,
      // full: true,
      outputType: 'png',
      canMove: true,
      fixedBox: false,
      original: false,
      canMoveBox: true,
      autoCrop: true,
      // 只有自动截图开启 宽度高度才生效
      autoCropWidth: props.width,
      autoCropHeight: props.height,
      centerBox: true,
      high: true,
      max: 99999,
      fixed: true,
      fixedNumber: [props.width, props.height]
    });
    const cropperVisible = ref(false);
    const cropper = ref(null);
    const picName = ref(''); // 图片名称

    const imgChange = response => {
      if (response.size / 1024 / 1024 > 1) {
        ElMessage.error('上传图片大于1mb!');
        return false;
      }
      // 打开弹窗
      picName.value = response.name;
      cropperVisible.value = true;
      option.value.img = URL.createObjectURL(response.raw);
      // form.value[field] = URL.createObjectURL(uploadFile.raw)
    };
    function blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = e => {
          resolve(e.target.result);
        };
        // readAsDataURL
        fileReader.readAsDataURL(blob);
        fileReader.onerror = () => {
          reject(new Error('blobToBase64 error'));
        };
      });
    }

    // 点击截取后触发
    const screenshot = () => {
      cropper.value.getCropBlob(async data => {
        const base64 = await blobToBase64(data);
        // file.value = base64
        emits('update:modelValue', base64);
        /*
        *   1.图片压缩，接收类型:File或Blob
            2.要使quality生效，被压缩图片的类型需要是`image/jpeg`或`image/webp`
            3.convertSize生效，被压缩图片类型：`image/webp`
        */
        // console.log(new window.File([data], picName.value, { type: 'image/webp' }))
        // eslint-disable-next-line no-new
        new Compressor(new window.File([data], picName.value, {
          type: 'image/webp'
        }), {
          quality: 0.7,
          convertSize: 4883,
          async success(result) {
            // console.log(new window.File([result], picName.value, { type: data.type }))
            await customLoad({
              file: new window.File([result], picName.value, {
                type: data.type
              })
            });
          },
          error(err) {
            console.log(err.message);
          }
        });
        cropperVisible.value = false;
      });
    };

    // 自动上传
    const customLoad = async file => {
      const formData = new FormData();
      formData.append('file', file.file);
      // 自个调用接口（文件流上传，后台返回图片的相对路径）
      const ossClient = await getOSSClient();
      const res = await ossClient.put(`his/${props.id}/${props.path}/${file.file.name}`, file.file);

      // const res = await uploadTenantImage(formData, props.id)
      // ruleForm用于后续的表单提交
      //   file.value = ''
      //   file.value = res
      //   ElMessage.success('上传成功')
      emits('update:modelValue', res.url);
    };
    const isImageShow = ref(false);
    const handleDelImage = () => {
      emits('update:modelValue', '');
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", {
        class: "container",
        onMouseover: _cache[1] || (_cache[1] = $event => isImageShow.value = true),
        onMouseout: _cache[2] || (_cache[2] = $event => isImageShow.value = false)
      }, [_withDirectives(_createElementVNode("div", {
        class: "mask",
        style: _normalizeStyle({
          height: __props.height / 2 + 'px',
          width: __props.width / 2 + 'px'
        })
      }, [_createVNode(_component_el_icon, {
        style: {
          "color": "#fff"
        },
        class: "avatar-uploader-icon",
        onClick: handleDelImage
      }, {
        default: _withCtx(() => [_createVNode(_unref(Delete))]),
        _: 1
      })], 4), [[_vShow, __props.modelValue && isImageShow.value]]), _createVNode(_component_el_upload, {
        accept: "image/jpeg,image/png,image/jpg",
        "http-request": customLoad,
        class: "avatar-uploader",
        "show-file-list": false,
        "on-change": imgChange,
        "auto-upload": false,
        disable: __props.modelValue && isImageShow.value
      }, {
        default: _withCtx(() => [__props.modelValue ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.modelValue,
          class: "avatar",
          style: _normalizeStyle({
            height: __props.height / 2 + 'px',
            width: __props.width / 2 + 'px'
          })
        }, null, 12, _hoisted_1)) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "#fff",
          class: "avatar-uploader-icon"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Plus))]),
          _: 1
        }))]),
        _: 1
      }, 8, ["disable"]), _createVNode(_component_el_dialog, {
        title: "图片剪裁",
        modelValue: cropperVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => cropperVisible.value = $event)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(VueCropper), {
          ref_key: "cropper",
          ref: cropper,
          img: option.value.img,
          outputSize: option.value.size,
          outputType: option.value.outputType,
          info: true,
          full: option.value.full,
          fixed: option.value.fixed,
          fixedNumber: option.value.fixedNumber,
          "can-move": option.value.canMove,
          "can-move-box": option.value.canMoveBox,
          "fixed-box": option.value.fixedBox,
          original: option.value.original,
          "auto-crop": option.value.autoCrop,
          "auto-crop-width": option.value.autoCropWidth,
          "auto-crop-height": option.value.autoCropHeight,
          "center-box": option.value.centerBox,
          high: option.value.high,
          mode: "cover",
          "max-img-size": option.value.max
        }, null, 8, ["img", "outputSize", "outputType", "full", "fixed", "fixedNumber", "can-move", "can-move-box", "fixed-box", "original", "auto-crop", "auto-crop-width", "auto-crop-height", "center-box", "high", "max-img-size"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: screenshot
        }, {
          default: _withCtx(() => [_createTextVNode("截取")]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"])], 32);
    };
  }
};